import React from 'react';

const DailyProgress = ({ stats, tweetsPostedToday = 0, dailyActions = {}, onDailyActionToggle }) => {
  const items = [
    {
      key: 'blogs',
      label: 'Publish blogs',
      auto: stats?.contentDraft > 0 && stats?.researchedToday > 0,
      autoLabel: stats?.contentDraft > 0 ? `${stats.contentDraft} drafts ready` : 'No drafts',
    },
    {
      key: 'tweets',
      label: 'Approve tweets',
      auto: tweetsPostedToday >= 6,
      autoLabel: `${tweetsPostedToday}/6 posted`,
    },
    {
      key: 'postBridgeReviewed',
      label: 'Approve Post-Bridge drafts',
      manual: true,
    },
    {
      key: 'outreach',
      label: 'Send outreach emails',
      manual: true,
    },
    {
      key: 'videoRecorded',
      label: 'Record / advance a video',
      manual: true,
    },
  ];

  const completedCount = items.filter(item => {
    if (item.manual) return !!dailyActions[item.key];
    return item.auto;
  }).length;

  return (
    <div className="bg-gray-800 border border-gray-700 rounded-xl px-4 py-3">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-[#F9FAFB]">Daily Progress</h3>
        <span className="text-xs text-[#9CA3AF]">{completedCount}/{items.length}</span>
      </div>
      <div className="space-y-2">
        {items.map((item) => {
          const checked = item.manual ? !!dailyActions[item.key] : item.auto;
          return (
            <div key={item.key} className="flex items-center gap-2">
              {item.manual ? (
                <input
                  type="checkbox"
                  checked={!!dailyActions[item.key]}
                  onChange={() => onDailyActionToggle?.(item.key, !dailyActions[item.key])}
                  className="w-4 h-4 rounded border-gray-600 bg-gray-700 accent-[#FFD700] cursor-pointer"
                />
              ) : (
                <span className={`w-4 h-4 flex items-center justify-center text-xs ${checked ? 'text-green-400' : 'text-[#4B5563]'}`}>
                  {checked ? '\u2713' : '\u25CB'}
                </span>
              )}
              <span className={`text-sm ${checked ? 'text-[#D1D5DB] line-through' : 'text-[#F9FAFB]'}`}>
                {item.label}
              </span>
              {item.autoLabel && (
                <span className="text-[10px] text-[#6B7280] ml-auto">{item.autoLabel}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DailyProgress;
